import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function AreaMaestranza() {
  const sectionsRef = useRef<(HTMLElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    sectionsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const setRef = (index: number) => (el: HTMLElement | null) => {
    sectionsRef.current[index] = el;
  };

  const servicios = [
    "Estructuras metálicas",
    "Estanques metálicos",
    "Tolvas",
    "Betoneras",
    "Remolque de todo tipo",
    "Mantención y reparación de maquinaria pesada",
    "Mantención planta de hormigó",
  ];

  const equipos = [
    "Soldaduras Autónomas",
    "Soldaduras Relativas",
    "Soldaduras Electrónicas",
    "Equipo Demoledor",
    "Esmeriles Angulares",
    "Taladros de Percusión",
    "Taladros de Pedestal y manual",
    "Compresores de Aire de alta y de baja",
    "Equipos de Oxígeno",
  ];

  const fabricaciones = [
    "Galpones de distintas dimensiones para la industria pisquera de la región",
    "Betoneras para equipos mixer",
    "Canoas de descarga primarias",
    "Canoas de descarga secundarias plegables",
    "Canoas auxiliares",
    "Buzones de carga",
    "Buzones de descarga",
    "Torres delanteras y traseras",
    "Bandejas tapabarros",
    "Estanques acumuladores de aire",
    "Estanques supresores de agua",
  ];

  const reparaciones = [
    "Reparaciones; Cambio de aletas y paletas envarilladas",
    "Cambio de doble fondo",
    "Cambio y reparaciones de manto de betoneras",
    "Cambio de reductores",
    "Reparacines estructurales en general de los equipos mixer",
  ];

  const reparacionesPlanta = [
    "Fabricación e instalación de polines de carga y de retorno",
    "Fabricación e instalación de estaciones de correas transportadoras",
    "Fabricación de moldajes para mega stock",
    "Reparación y cambio de planchas en buzones",
    "Instalación de planchas de desgaste",
    "Fabricación y montaje de galpones",
    "Fabricación de estanques metálicos para agua y combustibles",
    "Fabricación e instalación de carrocerias",
    "Fabricación e instalación de tolvas con sistema de levante hidráulico",
    "Reparaciones de baldes, con acero y soldaduras especiales",
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[420px] md:h-[520px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=industrial%20metal%20workshop%20with%20welding%20equipment%20and%20steel%20structures%2C%20professional%20manufacturing%20facility%2C%20orange%20and%20gray%20color%20scheme%2C%20modern%20industrial%20lighting%2C%20clean%20and%20organized%20workspace&width=1920&height=600&seq=maestranza-hero&orientation=landscape"
            alt="Área Maestranza"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1C2B38]/70 via-[#1C2B38]/50 to-[#1C2B38]/70"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center px-6">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 tracking-tight">
              ÁREA MAESTRANZA
            </h1>
            <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full"></div>
          </div>
        </div>
      </section>

      {/* Servicios Section */}
      <section
        ref={setRef(0)}
        className="py-16 md:py-24 px-6 opacity-0 translate-y-8 transition-all duration-700"
      >
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1C2B38] mb-6">
                Nuestro Enfoque
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                Nuestro enfoque se ha basado principalmente en las empresas
                productoras y distribuidoras de hormigón, mineras, constructoras,
                pesqueras y agroindustrias:
              </p>
              <div className="grid sm:grid-cols-2 gap-4">
                {servicios.map((servicio, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-orange-50 transition-colors duration-300"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-gray-700 font-medium text-sm">
                      {servicio}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <img
                src="https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/725694a8-d62c-4a64-a9c2-7ee3f487a705_WhatsApp-Image-2026-04-14-at-10.34.42-AM-6.jpeg?v=4e8914440fa99f3749f18550cbda8748"
                alt="Taller de Maestranza"
                className="w-full h-[400px] object-cover rounded-2xl shadow-lg"
              />
              <div className="absolute -bottom-6 -left-6 bg-orange-500 text-white p-6 rounded-xl shadow-lg">
                <p className="text-3xl font-bold">20+</p>
                <p className="text-sm opacity-90">Años de Experiencia</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipos Section */}
      <section
        ref={setRef(1)}
        className="py-16 md:py-24 px-6 bg-gray-50 opacity-0 translate-y-8 transition-all duration-700"
      >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1C2B38] mb-4">
              Equipos y Herramientas
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Poseemos una gran variedad de máquinas y herramientas para la
              ejecución de nuestros trabajos. Algunos de los equipos con que
              contamos en nuestra planta son:
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {equipos.map((equipo, index) => (
              <div
                key={index}
                className="bg-white p-5 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-lg">
                    <i className="ri-tools-line text-orange-500"></i>
                  </div>
                  <span className="text-gray-700 font-medium">{equipo}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Principales Obras Section */}
      <section
        ref={setRef(2)}
        className="py-16 md:py-24 px-6 opacity-0 translate-y-8 transition-all duration-700"
      >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-semibold mb-4">
              Experiencia Comprobada
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1C2B38] mb-4">
              Principales Obras Realizadas
            </h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Fabricaciones */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl">
                  <i className="ri-building-line text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1C2B38]">
                  Fabricaciones de:
                </h3>
              </div>
              <ul className="space-y-3">
                {fabricaciones.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center bg-orange-100 rounded-full flex-shrink-0 mt-0.5">
                      <i className="ri-arrow-right-s-line text-orange-500 text-xs"></i>
                    </div>
                    <span className="text-gray-600 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-500 italic">
                  <span className="font-semibold text-orange-500">Nota:</span>{" "}
                  Todos los productos mencionados anteriormente son instalados y
                  consideran un tratamiento de arenado y pintado (poliuretano).
                </p>
              </div>
            </div>

            {/* Reparaciones */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1C2B38] rounded-xl">
                  <i className="ri-tools-fill text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1C2B38]">
                  Reparaciones y Cambios de:
                </h3>
              </div>
              <ul className="space-y-3">
                {reparaciones.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center bg-[#1C2B38]/10 rounded-full flex-shrink-0 mt-0.5">
                      <i className="ri-arrow-right-s-line text-[#1C2B38] text-xs"></i>
                    </div>
                    <span className="text-gray-600 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 relative h-[180px] rounded-xl overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/42fd5c15-24ac-4646-8344-739958f1d179_WhatsApp-Image-2026-04-14-at-10.34.42-AM-5.jpeg?v=600381cad674978266e93ac33a53422c"
                  alt="Reparaciones"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reparaciones en Planta Section */}
      <section
        ref={setRef(3)}
        className="py-16 md:py-24 px-6 bg-[#1C2B38] opacity-0 translate-y-8 transition-all duration-700"
      >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Reparaciones en la Planta
            </h2>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Servicios especializados de fabricación y reparación directamente
              en nuestras instalaciones
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {reparacionesPlanta.map((item, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition-colors duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-lg mb-4">
                  <i className="ri-settings-3-line text-white"></i>
                </div>
                <p className="text-white text-sm leading-relaxed">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 px-6 bg-orange-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
            ¿Necesitas un presupuesto para tu proyecto?
          </h2>
          <p className="text-white/90 mb-8 text-lg">
            Contáctanos y te ayudaremos con tus necesidades de maestranza
          </p>
          <Link
            to="/contacto"
            className="inline-flex items-center gap-2 bg-white text-orange-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors duration-300 cursor-pointer"
          >
            <span>Solicitar Cotización</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}